<div #container>
  <button class="btn btn-small btn-ghost pull-right" (click)="clear()" [disabled]="!signature">
    <span class="small-text">{{ 'clear' | translate }}</span>
  </button>

  <label class="label-form-control">{{ 'draw-your-signature' | translate }}</label>
  <signature-pad [options]="options" (onBeginEvent)="drawBegin()" (onEndEvent)="drawComplete()"> </signature-pad>
</div>
